import DepsService from 'services/dependencies';

const NAMESPACE = 'terms-page_';
export const RECEIVE_TERMS = `${NAMESPACE}RECEIVE_TERMS`;
export const RECEIVE_TERM_BY_ID = `${NAMESPACE}RECEIVE_TERM_BY_ID`;
export const REQUEST_TERM_BY_ID = `${NAMESPACE}REQUEST_TERM_BY_ID`;
export const REQUEST_TERMS_HISTORY = `${NAMESPACE}REQUEST_TERMS_HISTORY`;

const requestTerms = () => {
  return {
    type: REQUEST_TERMS_HISTORY,
  };
};

const requestTermById = () => {
  return {
    type: REQUEST_TERM_BY_ID,
  };
};

export const receiveTerms = (payload) => {
  return {
    type: RECEIVE_TERMS,
    list: payload,
  };
};

export const receiveTermById = (payload) => {
  return {
    type: RECEIVE_TERM_BY_ID,
    selectedTerm: payload,
  };
};

export const fetchTerms = () => {
  return (dispatch) => {
    const getAllTermsURL = DepsService.rest.cms.terms.allVersions.url;
    const jurisdictionId = DepsService.model.session.jurisdiction;

    dispatch(requestTerms());
    return DepsService.restSrv
      .get('app', getAllTermsURL, null, { jurisdictionId })
      .then((response) => dispatch(receiveTerms(response)));
  };
};

export const fetchTermByID = (version) => {
  return (dispatch) => {
    const getTermByIdURL = DepsService.rest.cms.terms.versionDetails.url;
    const jurisdictionId = DepsService.model.session.jurisdiction;

    dispatch(requestTermById());
    return DepsService.restSrv
      .get('app', getTermByIdURL, null, { jurisdictionId, version })
      .then((response) => dispatch(receiveTermById(response)));
  };
};



// WEBPACK FOOTER //
// ./src/modules/terms-preview/actions/terms-preview.actions.js